export const TagComponent = ({ icon, label, color = "green" }) => {
    const bg = {
        green: "bg-green-100",
        pink: "bg-pink-100",
        blue: "bg-blue-100",
    }[color];

    const text = {
        green: "text-green-700",
        pink: "text-pink-700",
        blue: "text-blue-700",
    }[color];

    const hover = {
        green: "hover:bg-green-200",
        pink: "hover:bg-pink-200",
        blue: "hover:bg-blue-200",
    }[color];

    const iconColor = {
        green: "text-green-600",
        pink: "text-pink-600",
        blue: "text-blue-600",
    }[color];

    return (
        <span
            className={`flex items-center gap-2 ${bg} ${text} px-4 py-2 rounded-full font-semibold text-sm shadow-sm transition ${hover}`}
        >
            <span className={iconColor}>{icon}</span>
            {label}
        </span>
    );
};
